import { useEffect } from "react";
import { Button, Chip, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

import PaginationGridView from "../../components/views/paginationGridView";
import useUsuariosClientesState from "../../hooks/useUsuariosClientesState";

const nomes = (itens) => itens?.map((item) => item.nome).join(", ") || "";

const UsuariosClientes = () => {
  const states = useUsuariosClientesState();
  const navigate = useNavigate();

  useEffect(() => {
    states.submit.set();
  }, []);

  const columns = [
    { field: "name", headerName: "Nome", flex: 1 },
    { field: "username", headerName: "Usuário", flex: 1 },
    { field: "email", headerName: "E-mail", flex: 1.3 },
    { field: "postos", headerName: "Postos", flex: 1.2, valueGetter: ({ row }) => nomes(row.postos) },
    { field: "tipos_tarefa", headerName: "Tipos de tarefa", flex: 1.2,
      valueGetter: ({ row }) => nomes(row.tipos_tarefa) },
    { field: "is_active", headerName: "Situação", width: 100,
      renderCell: ({ value }) => (
        <Chip size="small" color={value ? "success" : "default"} label={value ? "Ativo" : "Inativo"} />
      ) },
    { field: "acoes", headerName: "Ações", width: 80, sortable: false,
      renderCell: ({ row }) => (
        <Tooltip title="Editar Usuário Cliente" placement="left" arrow>
          <Button onClick={() => navigate(`/gestor/usuarios-clientes/${row.id}`)}
            sx={{ minWidth: 0, padding: 0 }}>
            <EditIcon />
          </Button>
        </Tooltip>
      ) },
  ];

  return (
    <PaginationGridView title="Usuários Clientes" nomeItem="Usuário Cliente" states={states}
      rows={states.usuarios.value} columns={columns}
      urlAdd="/gestor/usuarios-clientes/cadastro" urlVoltar="/gestor/dashboard"
      onClickPesquisa={() => states.submit.set(1)} />
  );
};

export default UsuariosClientes;
